import _Replay from "@mui/icons-material/Replay";
import _Announcement from "@mui/icons-material/Announcement";
import React from 'react';
import styled from 'styled-components';
import { SIZES, Typography } from '@fupa/fupa-uikit';
import { Content } from 'app/styles/content';
import { Helmet } from 'react-helmet-async';
import { TITLE_POSTFIX } from 'app/seo/seo.constants';
import { Button } from '@mui/material';
import { ssrRequestContext } from 'app/ssrContext';
const Wrapper = styled(Content).withConfig({
  componentId: "sc-1a5ppg6-0"
})(["&&&{padding:", " ", ";height:calc(100vh - ", ");margin:auto;}"], props => props.top ? props.top : SIZES[72], SIZES['16'], props => props.top ? props.top : SIZES[72]);
const Text = styled(Typography).withConfig({
  componentId: "sc-1a5ppg6-1"
})(["&&&{text-align:center;}"]);
const Container = styled.div.withConfig({
  componentId: "sc-1a5ppg6-2"
})(["display:flex;width:100%;flex-direction:column;align-items:center;padding-top:", ";"], SIZES['32']);
const StyledAnnouncement = styled(_Announcement).withConfig({
  componentId: "sc-1a5ppg6-3"
})(["font-size:", ";margin-bottom:", ";"], SIZES['72'], SIZES['32']);
const NetworkErrorPage = _ref => {
  let {
    top
  } = _ref;
  if (typeof window === 'undefined') {
    ssrRequestContext.cacheControl = 'no-cache, no-store';
  }
  const handleReload = () => {
    window.location.reload();
  };
  return /*#__PURE__*/React.createElement(Wrapper, {
    id: "network-error",
    top: top,
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "NetworkErrorPage",
    "data-sentry-source-file": "NetworkErrorPage.tsx"
  }, /*#__PURE__*/React.createElement(Container, {
    "data-sentry-element": "Container",
    "data-sentry-source-file": "NetworkErrorPage.tsx"
  }, /*#__PURE__*/React.createElement(Helmet, {
    title: "Netzwerk Fehler".concat(TITLE_POSTFIX),
    "data-sentry-element": "Helmet",
    "data-sentry-source-file": "NetworkErrorPage.tsx"
  }), /*#__PURE__*/React.createElement(StyledAnnouncement, {
    color: "warning",
    "data-sentry-element": "StyledAnnouncement",
    "data-sentry-source-file": "NetworkErrorPage.tsx"
  }), /*#__PURE__*/React.createElement(Text, {
    variant: "headline2",
    component: "h1",
    "data-sentry-element": "Text",
    "data-sentry-source-file": "NetworkErrorPage.tsx"
  }, "Zeit\xFCberschreitung der Anfrage"), /*#__PURE__*/React.createElement(Text, {
    variant: "subheading",
    component: "p",
    "data-sentry-element": "Text",
    "data-sentry-source-file": "NetworkErrorPage.tsx"
  }, "Die Seite ben\xF6tigt zu lange zum Laden. Bitte \xFCberpr\xFCfe deine Internetverbindung und versuche es erneut."), /*#__PURE__*/React.createElement(Button, {
    sx: {
      marginTop: SIZES['32']
    },
    color: "secondary",
    onClick: handleReload,
    startIcon: /*#__PURE__*/React.createElement(_Replay, {
      color: "inherit"
    }),
    variant: "contained",
    size: "small",
    "data-sentry-element": "Button",
    "data-sentry-source-file": "NetworkErrorPage.tsx"
  }, "Erneut Versuchen")));
};
export default NetworkErrorPage;